export default __webpack_public_path__ + "static/media/herobanner.483abfcc.jpeg";